export default __webpack_public_path__ + "static/sig-ico-7a1031c6f8e644f1e5f220c04d6230f3.png";